import React from 'react';
import Input from 'Components/Input';
import Autosuggest from './AutoSuggest';
import { ReactComponent as DeleteIcon } from "Icons/delete.svg";
import { ReactComponent as CancelIcon } from 'Icons/cancel.svg';
import { ReactComponent as DownloadIcon } from "Icons/download.svg";
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import Upload from "Components/Upload";
import Dropdown from 'Components/Dropdown';

const Consignee = (props) => {
	const { trip, tripIndex, onSelectLocation, locationList, onChangeTrip, pricingBasis, onDeleteTrip, openProviderPopup, onDeleteTransporter, vehicleTypes, uploadTrips, onDownload } = props;
    return (
        <div style={{'background': '#D4E1FB'}}>
            {trip.consigneeCount === 1 && (<div style={{'borderBottom': '1px solid #224D9C'}} className='flex flex-between fBold pb-5'>
                <div className='pt-10 fs-18'>Consignee</div>
                {/* <div className='flex flex-between wt-400'>
                    <div className=' fs-16 fBold flex mt-5 curP' onClick={() =>onDownload(false, 2)}>
                        <DownloadIcon className='wt-15 ht-25 mr-5'/>
                        <div className='mt-5'>{'Template'}</div>
                    </div>
                    <div className='fs-16 fBold flex mt-5 curP'>
                        <Upload onChange={(file) => uploadTrips(file, 2)} value="Upload File">
                            <button className='fs-16 fBold flex' style={{'background': '#D4E1FB'}}>
                            <UploadIcon className='wt-15 ht-25 mr-5'/><div className='mt-5'>Upload</div></button>
                        </Upload> 
                    </div>
                    <div className='fs-16 fBold flex mt-5 mr-20 curP'  onClick={() =>onDownload(true, 2)}>
                        <DownloadIcon className='wt-15 ht-25 mr-5'/>
                        <div className='mt-5'>{'Download Details'}</div>
                    </div>
                </div> */}
            </div>)}
            <div className='flex flex-between pt-10'>
                <div className='fBold mt-10 fs-20 ml-10"'>{trip.consigneeCount}.</div>
                <div>
                    <button className='ph-20 button-bg-color white-color fBold br-5 ht-40 fs-16 mr-10' onClick={() => openProviderPopup(tripIndex, 2)}>+ Add Provider</button>
                </div>
            </div>
			<div className='flex pv-10 ph-10'>
				<div className='bg-white pv-10 ph-10 col-1'>
					<div className='flex mb-10'>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>From (ICD Destination)</div>
							<Autosuggest
								onChange={(e) => props.onChange(e, tripIndex, 'origin')}
								inputValue={((trip.stops || [])[0] || {}).location}
								onSelect={(option) => onSelectLocation(option, tripIndex, 'origin')}
								options={locationList || []}
								type={`origin_${tripIndex}`}
								displayName={'source'}
                                singleMode={true}
							/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>To</div>
							<Autosuggest
								onChange={(e) => props.onChange(e, tripIndex, 'destination')}
								inputValue={((trip.stops || [])[1] || {}).location}
								onSelect={(option) => onSelectLocation(option, tripIndex, 'destination')}
								options={locationList || []}
								type={`destination_${tripIndex}`}
								displayName={'destination'}
                                singleMode={true}
							/>
						</div>
						<div className='wt-250 fSemibold mr-10'>
							<div className='fs-16 mb-5'>Vehicle Type</div>
							<Dropdown 
								items={vehicleTypes}
								displayKey="name"
								selectedItem={(vehicleTypes || []).find(el => (el.value === (trip.vehicle_details || {}).vehicle_type))}
								name="vehicle_type" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'vehicle_type')}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>kms</div>
							<Input 
								value={trip.distance}
								onChange={(e) => onChangeTrip(e, tripIndex, 'distance')}
								disabled={true}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>No. Of Trucks</div>
							<Input 
								value={trip.no_of_trucks}
								onChange={(e) => onChangeTrip(e, tripIndex, 'no_of_trucks')}
							/>
						</div>
                        <div className='mt-40'><DeleteIcon className='wt-25 ht-25 curP' onClick={() => onDeleteTrip(tripIndex)}/></div>
					</div>
					<div className='flex'>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Route Code</div>
							<Input 
								type="text"
								value={trip.route_code}
								onChange={onChangeTrip}
								disabled={true}
							/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Pricing Basis</div>
							<Dropdown 
								items={pricingBasis}
								displayKey="name"
								selectedItem={(pricingBasis || []).find(el => (el.name === trip.pricing_basis_name))}
								name="movement_type" 
								label="Select" 
								onSelect={(option) => props.onSelect(option, tripIndex, 'pricing_basis_name')}
							/>
						</div>
						<div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Market Rate</div>
							<Input 
								type="number"
								value={trip.market_rate}
								onChange={(e) => onChangeTrip(e, tripIndex, 'market_rate')}
							/>
						</div>
                        <div className='wt-250 mr-10 fSemibold'>
							<div className='fs-16 mb-5'>Ceiling Price</div>
							<Input 
								type="number"
								value={(trip['bidding_and_payments'] || {}).qbr}
								onChange={(e) => onChangeTrip(e, tripIndex, 'qbr')}
							/>
						</div>
						<div className='wt-250 fSemibold'>
							<div className='fs-16 mb-5'>Internal Remarks</div>
							<Input 
								value={trip.remarks}
								onChange={(e) => onChangeTrip(e, tripIndex, 'remarks')}
							/>
						</div>
                        <div className='mt-40'></div>
					</div>
				</div>
			</div>
			{(trip.transporters_group || []).length > 0 && <div className='mt-10 border-light-blue-2'>
				<div className={'fs-16 fBold pv-10 ph-10'} style={{'background': '#D4E1FB'}}>Transporters</div>
				{trip.transporters_group.map((transGroup, transGroupIndex) => (
					(transGroup.transporters || []).map((transporter, transporterIndex) => (
						<div className="fs-16 mb-10 inBlock border-bottom-light-2 tCenter mt-10 pv-5 pl-15 pr-15 br-15 ml-20" style={{'background': '#EEF3FD'}}>{transporter.name} <CancelIcon className='ml-5 mr-2 wt-15 ht-10' fill='#EEF3FD' onClick={() => onDeleteTransporter(tripIndex, transGroupIndex, transporterIndex)}/></div>
					))
				))}
			</div>}
        </div>
    )
}

export default Consignee;